var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4879 3.01175H7.83493C5.75493 3.00375 4.04993 4.66175 4.00093 6.74075V17.4537C3.95493 19.5667 5.62993 21.3177 7.74293 21.3647C7.77393 21.3647 7.80393 21.3657 7.83493 21.3647H15.8239C17.9179 21.2797 19.5679 19.5497 19.5529 17.4537V8.28775L14.4879 3.01175Z",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2252 3V5.909C14.2252 7.329 15.3732 8.48 16.7932 8.484H19.5482",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0382 15.6085H8.63824",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9933 11.856H8.63733",
    stroke: "#5C5C64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/listing.024ce160e92a500af94a8c8f614f63ce.svg";
export { ForwardRef as ReactComponent };